const PRIVACY_BTN = '[js-hook-privacy-btn]'

class DisabledElement {
  constructor(element) {
    this.element = element;
    this.bindEvents();
  }


  /**
   * On change update visibility of element
   */
  onSelectChange() {
    const button = document.querySelector(PRIVACY_BTN);
    if (this.element.checked) {
      button.classList.remove('disabled')
    } else {
      button.classList.add('disabled')
    }
  }

  /**
   * Bind all general events
   */
  bindEvents() {
    this.element.addEventListener('change', () => {
      this.onSelectChange();
    });
  }
}

export default DisabledElement;
